import { base } from "./_internal";

/**
 * RequestError
 */
export class RequestError extends base.ApplicationError {
	public static override readonly code: number = 400;

	constructor(message?: string) {
		const trueProto = new.target.prototype;
		super(message ?? "Bad Request");
		Object.setPrototypeOf(this, trueProto);
	}
}

/**
 * NotFoundError
 */
export class NotFoundError extends RequestError {
	public static override readonly code: number = 404;

	constructor(message?: string) {
		const trueProto = new.target.prototype;
		super(message ?? "Not Found");
		Object.setPrototypeOf(this, trueProto);
	}
}

/**
 * RequestTimeoutError
 */
export class RequestTimeoutError extends RequestError {
	public static override readonly code: number = 408;

	constructor(message?: string) {
		const trueProto = new.target.prototype;
		super(message ?? "Not Found");
		Object.setPrototypeOf(this, trueProto);
	}
}

/**
 * ConflictError
 */
export class ConflictError extends RequestError {
	public static override readonly code: number = 409;

	constructor(message?: string) {
		const trueProto = new.target.prototype;
		super(message ?? "Not Found");
		Object.setPrototypeOf(this, trueProto);
	}
}

/**
 * SignupError
 */
export class SignupError extends RequestError {
	public static override readonly code: number = 454;

	constructor(message?: string) {
		const trueProto = new.target.prototype;
		super(message ?? "Signup error");
		Object.setPrototypeOf(this, trueProto);
	}
}

/**
 * OrgJoinInviteError
 */
export class OrgJoinInviteError extends RequestError {
	public static override readonly code: number = 455;

	constructor(message?: string) {
		const trueProto = new.target.prototype;
		super(message ?? "Org join error");
		Object.setPrototypeOf(this, trueProto);
	}
}

/**
 * JoinError
 */
export class JoinError extends RequestError {
	public static override readonly code: number = 456;

	constructor(message?: string) {
		const trueProto = new.target.prototype;
		super(message ?? "Join error");
		Object.setPrototypeOf(this, trueProto);
	}
}
